import React from "react";

const Thumbnail = () => {
  return (
    <>
      <img
        className="m-2 rounded-full border-4 border-solid border-sky-500"
        alt="portfolio pic"
        src="https://hcandelariapersonalportfolio.s3.amazonaws.com/images/portofolio/profile.jpg"
      />
    </>
  );
};

export default Thumbnail;
